import React, { useEffect, useState } from "react"
import Select from "react-select"

import MetaTags from "react-meta-tags"
import { map } from "lodash"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  InputGroup,
  CardTitle,
} from "reactstrap"
import classnames from "classnames"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"

//Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"

import { getEndUsersCount, getEndUser } from "helpers/repository"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import AccountDetails from "./Dashboard/AccountDetails"
import Statistics from "./Dashboard/Statistics"
import Performance from "./Performance/Performance"
import Transactions from "./Transactions/Transactions"
import SecurityDetails from "./Security/SecurityDetails"
import Password from "./Security/Password"
import PersonalDetails from "./Contact/PersonalDetails"
import ContactDetails from "./Contact/ContactDetails"
import MarketingOptIn from "./Contact/MarketingOptIn"
import Tickets from "./Tickets/Tickets"
import PromotionRewards from "./Promotions/PromotionRewards"
import Messages from "./Promotions/Messages"
import Notes from "./Notes/Index"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import axios from "axios";
import {API_URL, sitename} from "../../constants/constants";
import ReferAFriend from "./Promotions/ReferAFriend";

const EndUsers = props => {
  const [startDate, setStartDate] = useState(new Date())
  const [activeTab, setActiveTab] = useState("1")
  const [count, setCount] = useState([])
  const [searchUserId, setSearchUserId] = useState("")
  const [endUser, setEndUser] = useState({})
  const [modelData, setModalData] = useState([])

  const handleChange = date => {
    setStartDate(date)
  }

  useEffect(async () => {
    try {
      const response = await getEndUsersCount()

      setCount(response.data.data)
    } catch (e) {
      console.error(e)
      setCount([])
    }
  }, [])

  const search = async () => {
    if ((searchUserId ?? "").length > 0) {
      try {
        const response = await getEndUser(searchUserId)

        const user = response.data.data

        if (user) {
          setEndUser(user)
          toastr.success(`Found ${user.phone_number}`)
        } else {
          toastr.error("User not found")
        }
      } catch (e) {
        toastr.error("Error connecting server")

        console.error(e)
      }
    } else {
      toastr.error("Please enter a valid User ID")
    }
  }

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }
  const callById =id => {
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/sport-tickets?id=${id}&unsetPagination=${true}`,
    })
        .then(function (response) {
          setModalData(response?.data?.data[0])
        })
        .catch(function (response) {})
  }
  const callByJackpotId =(jackpotId,id) => {
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/jackpot-bet-reports/${jackpotId}?ticketid=${id}`,
    })
        .then(function (response) {
          setModalData(response?.data?.data[0])
        })
        .catch(function (response) {})
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="End Users" />

          <Card>
            <CardBody>
              <Row>
                <Col xs={12} sm={12} md={12} lg={6}>
                  <Row>
                    <Col xs={6} sm={6} md={6} lg={8}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-firstname-Input">
                          User Number (Enter Last Ten Digits)
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="formrow-firstname-Input"
                          onChange={e => {
                            setSearchUserId(e.target.value)
                          }}
                        />
                      </div>
                    </Col>
                    <Col
                      xs={6}
                      sm={6}
                      md={6}
                      lg={4}
                      className="d-flex flex-column justify-content-end"
                    >
                      <div className="mb-3">
                        <Label
                          htmlFor="formrow-firstname-Input"
                          style={{ visibility: "hidden" }}
                        >
                          User Number
                        </Label>

                        <button
                          type="submit"
                          className="btn btn-primary w-md form-control"
                          onClick={() => {
                            search()
                          }}
                        >
                          Search
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col sm={6} md={4} lg={6}></Col>
              </Row>
              <Row
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Col xs={6} sm={6} md={6} lg={3}>
                  <Row>
                    <Col xs={6} sm={6} md={6} lg={6}>
                      <Label className="form-label">Total Users</Label>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6}>
                      <p className="text-muted fw-medium form-label">
                        {count ? Number(parseFloat(count['end_user_count'] ?? 0)).toLocaleString('en-GB') : 0}
                      </p>
                    </Col>
                  </Row>
                </Col>
                <Col xs={6} sm={6} md={6} lg={3}></Col>
                <Col xs={6} sm={6} md={6} lg={3}>
                  <Row>
                    <Col xs={6} sm={6} md={6} lg={6} className="text-xl-end">
                      <Label className="form-label">Total Balance</Label>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6}>
                      <p className="text-muted fw-medium form-label">{count ? Number(parseFloat(count['total_cash_balance'] ?? 0).toFixed(2)).toLocaleString('en-GB') : 0}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>

          {Object.keys(endUser).length > 0 ? (
            <Row>
              <Col lg="12">
                <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "1",
                      })}
                      style={{ backgroundColor: "#F8F8FB" }}
                      onClick={() => {
                        toggleTab("1")
                      }}
                    >
                      Dashboard
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "2",
                      })}
                      style={{ backgroundColor: "#F8F8FB" }}
                      onClick={() => {
                        toggleTab("2")
                      }}
                    >
                      Performance
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "3",
                      })}
                      onClick={() => {
                        toggleTab("3")
                      }}
                      style={{ backgroundColor: "#F8F8FB" }}
                    >
                      Transactions
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "4",
                      })}
                      onClick={() => {
                        toggleTab("4")
                      }}
                      style={{ backgroundColor: "#F8F8FB" }}
                    >
                      Security
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "5",
                      })}
                      onClick={() => {
                        toggleTab("5")
                      }}
                      style={{ backgroundColor: "#F8F8FB" }}
                    >
                      Contact Details
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "6",
                      })}
                      onClick={() => {
                        toggleTab("6")
                      }}
                      style={{ backgroundColor: "#F8F8FB" }}
                    >
                      Tickets
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "7",
                      })}
                      onClick={() => {
                        toggleTab("7")
                      }}
                      style={{ backgroundColor: "#F8F8FB" }}
                    >
                      Promotions
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "8",
                      })}
                      onClick={() => {
                        toggleTab("8")
                      }}
                      style={{ backgroundColor: "#F8F8FB" }}
                    >
                      Notes
                    </NavLink>
                  </NavItem>
                </ul>

                <TabContent activeTab={activeTab} className="p-3">
                  <TabPane tabId="1" id="dashboard">
                    <Row>
                      <AccountDetails userData={endUser} />
                      <Statistics userData={endUser} />
                    </Row>
                  </TabPane>
                  <TabPane tabId="2" id="performance">
                    <Row>
                      <Performance userId={endUser.id} />
                    </Row>
                  </TabPane>
                  <TabPane tabId="3" id="transactions">
                    <Transactions userId={endUser.id} />
                  </TabPane>
                  <TabPane tabId="4" id="security">
                    <Row>
                      <SecurityDetails userData={endUser} />
                      <Password userData={endUser} />
                    </Row>
                  </TabPane>
                  <TabPane tabId="5" id="contact">
                    <Row>
                      <Col sm={12} md={12} lg={6}>
                        <PersonalDetails userData={endUser} />
                      </Col>
                      <Col sm={12} md={12} lg={6}>
                        <Row>
                          <Col sm={12} md={12} lg={12}>
                            <ContactDetails userData={endUser} />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={12} md={12} lg={12}>
                            <MarketingOptIn />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="6" id="tickets">
                    <Row>
                      <Tickets
                          userId={endUser.id}
                          modelData={modelData}
                          callById={(id) => {
                            callById(id)
                          }}
                          callByJackpotId={(jackpotId,id) => {
                            callByJackpotId(jackpotId,id)
                          }}
                      />
                    </Row>
                  </TabPane>
                  <TabPane tabId="7" id="promotions">
                    <Row>
                      <PromotionRewards   userId={endUser.id} />
                      <ReferAFriend userId={endUser.id}/>
                    </Row>
                    <Row>
                      <Messages userData={endUser} />
                    </Row>
                  </TabPane>
                  <TabPane tabId="8" id="notes">
                    <Row>
                      <Notes userData={endUser}/>
                    </Row>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col></Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(EndUsers)
